import styled from "styled-components";
import { CircleButton } from "_c/button";

export const Wrap = styled.div`
  position: relative;
  z-index: 10;
`;

export const MainLine = styled.div`
  display: flex;
  align-items: center;
  background: var(--bg-paper);
  border-radius: var(--root-br);
  padding: 15px;
  border-top-left-radius: ${({ isSticky }) =>
    isSticky ? 0 : "var(--root-br)"};
  border-top-right-radius: ${({ isSticky }) =>
    isSticky ? 0 : "var(--root-br)"};
  transition: border-radius 0.3s ease, background-color 0.75s ease,
    box-shadow 0.3s ease;
  @media (max-width: 1199px) {
    flex-direction: column;
  }
`;
export const FiltersButton = styled(CircleButton)`
  width: 40px;
  height: 40px;
  margin: 0 3px;
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
`;
